import { Termine_DesignAuswahl } from '@/gql/graphql';

export enum TerminDesignAuswahl {
  V1 = 'V1',
  V2 = 'V2',
}

export function getDesignAuswahlStringFromTerminDesignAuswahl(
  designAuswahl: TerminDesignAuswahl,
) {
  switch (designAuswahl) {
    case TerminDesignAuswahl.V1:
      return 'V1';
    case TerminDesignAuswahl.V2:
      return 'V2';
    default:
      return '';
  }
}

export const terminDesignAuswahlToGraphQLMap: Record<
  TerminDesignAuswahl,
  Termine_DesignAuswahl
> = {
  [TerminDesignAuswahl.V1]: Termine_DesignAuswahl.V1,
  [TerminDesignAuswahl.V2]: Termine_DesignAuswahl.V2,
} as const satisfies Record<TerminDesignAuswahl, Termine_DesignAuswahl>;
